import { IApiService } from 'src/services/IApiService';
import Sleva from '../models/Rozvoz';
import Rozvoz from '../models/Rozvoz';
import moment from 'moment';
import { observable } from 'mobx';

export default class RozvozStore {
    @observable public rozvozy: Rozvoz[] = [];

    private api: IApiService;
    constructor(api: IApiService) {
        this.api = api;
    }

    public loadByDate(week: Date): Promise<boolean> {
        this.rozvozy = [];
        const endOfWeek = moment(week).endOf('week');
        return new Promise(resolve => {
            this.api.getRozvozByDate(week, endOfWeek.toDate())
                .then(a => {
                    a.map(rozvoz => {
                        this.rozvozy.push(rozvoz);
                    })
                    resolve(true);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/RozvozStore.tsx